import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface ILapAddOnProd {
  prod: string;
  prodType: string;
  prodName: string;
  insuranceProducts: string;
  premiumPayable: string;
  SumAssured: string;
  policyTenureYrs: string;
  nomineeName: string;
  nomineeRel: string;
  nomineeMob: string;
  isSelected: boolean;
}

export interface ILapInsertApiRequest {
  mobileNo: string;
  id: string;
  offerId: string;
  eventCode: string;
  pageName: string;
  journeyName: string;
  productName: string;
  customerType: string;
  saveForLaterFlag: boolean;
  loanType: string;
  offerName: string;
  employmentType: string;
  offerAmount: string;
  requestedLoanAmount: string;
  requestedTenorInMonths: string;
  initialTenor: string;
  subsequentTenor: string;
  requestedRoi: string;
  loanVariant: string;
  EMI: string;
  hybridEmiAmt: string;
  droplineEmiAmt: string;
  addOnProd: ILapAddOnProd[] | null;
  appId?: string;
  apiVersion: string;
  appVersion: string;
  sourceSystem: string;
  srcChannel: string;
}

export type ILapInsertApiResponse = {
  id: string;
  eventCode: string | null;
  journeyName: string | null;
  newLoanAmt: string | null;
  netDisbursalAmt: string | null;
  chargeDetails: string | null;
};

export const lapInsert = async (
  data: ILapInsertApiRequest
): Promise<IResponse<ILapInsertApiResponse>> => {
  try {
    const response = await encryptedRequest<ILapInsertApiResponse, ILapInsertApiRequest>({
      method: "POST",
      url: API_PATHS.lapInsert,
      data: { ...data },
    });

    return response;
  } catch (error) {
    // this can be replaced once new relic implemented
    console.error(error);
    throw error;
  }
};
